<div class="container">
    <mat-icon>search</mat-icon>
    <input class="card" [placeholder]="placeholder" type="text" (input)="inputChanged($event)">
</div>